import { getFromStorage } from './getFromStorage';

export function isEUAccount(): boolean {
	return (getFromStorage(sessionStorage, 'apiDomain') as string)
		?.toLocaleLowerCase()
		.endsWith('.eu');
}
